export default __webpack_public_path__ + "static/media/TL04.f26ca17f.mp3";